module.exports = __webpack_public_path__ + "3_17_13_21_27/img/no-pictures.4299876.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/no-pictures.png
// module id = dKLy
// module chunks = 1